import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["itemSelect", "itemSkuSelect"]
  static values = {
    itemSkusUrl: String
  }

  connect() {
    this.updateItemSkuOptions()
  }

  async itemChanged() {
    await this.updateItemSkuOptions()
  }

  async updateItemSkuOptions() {
    const itemId = this.itemSelectTarget.value

    if (!itemId) {
      // Show all item_skus when no item is selected
      this.itemSkuSelectTarget.disabled = false
      this.itemSkuSelectTarget.innerHTML = '<option value="">Select size...</option>'

      try {
        const response = await fetch(`${this.itemSkusUrlValue}`)
        const data = await response.json()

        data.forEach(sku => {
          const option = document.createElement('option')
          option.value = sku.id
          option.textContent = `${sku.item_name} - ${sku.name}`
          this.itemSkuSelectTarget.appendChild(option)
        })
      } catch (error) {
        console.error('Error fetching item skus:', error)
      }
    } else {
      // Show only item_skus for selected item
      this.itemSkuSelectTarget.disabled = false
      this.itemSkuSelectTarget.innerHTML = '<option value="">Select size...</option>'

      try {
        const response = await fetch(`${this.itemSkusUrlValue}?item_id=${itemId}`)
        const data = await response.json()

        data.forEach(sku => {
          const option = document.createElement('option')
          option.value = sku.id
          option.textContent = sku.name
          this.itemSkuSelectTarget.appendChild(option)
        })
      } catch (error) {
        console.error('Error fetching item skus:', error)
      }
    }

    this.itemSkuSelectTarget.dispatchEvent(new CustomEvent("searchable-select:sync", { bubbles: false }))
  }
}
